module.exports = __webpack_public_path__ + "static/img/popmazecafe.b2c45821.png";